module.exports = __webpack_public_path__ + "img/office5_7-8-2021.0a8f2dbc.jpg";